import { configureStore, ThunkAction, Action } from "@reduxjs/toolkit";
import { authService } from "./services/authService";
import authReducer from "./slices/authSlice";
import allUserReducer from "./slices/allUserSlice";
import { allUserService } from "./services/allUserService";
import departmentMasterReducer from "./slices/departmentMasterSlice";
import { departmentMasterService } from "./services/departmentMasterService";
import projectMasterReducer from "./slices/projectMasterSlice";
import { projectMasterService } from "./services/projectMasterService";
import projectTypeMasterReducer from "./slices/projectTypeMasterSlice";
import { projectTypeMasterService } from "./services/projectTypeMasterService";
import phaseMasterReducer from "./slices/phaseMasterSlice";
import { phaseMasterService } from "./services/phaseMasterService";
import auditReducer from "./slices/auditSlice";
import { auditFrameworkService } from "./services/auditFrameworkService";
import { auditService } from "./services/auditService";
import auditFrameworkReducer from "./slices/auditFrameworkSlice";
import companyReducer from "./slices/companySlice";
import { companyService } from "./services/companyService";
import groupMasterRreducer from "./slices/groupMasterSlice";
import { groupMasterService } from "./services/groupMasterService";
import generatePdfRreducer from "./slices/pdfSlice";
import { pdfService } from "./services/pdfService";
import { allUserRoleService } from "./services/userRoleService";
import { allUserGroupService } from "./services/userGroupService";
import allUserRoleReducer from "./slices/allUserRoleSlice";
import allUserGroupReducer from "./slices/allUserGroupSlice";
import statesReducer from "./slices/statesSlice";
import { stateService } from "./services/stateService";
import countryReducer from "./slices/countrySlice";
import { countryService } from "./services/countryService";
import packageMasterReducer from "./slices/packageMasterSlice";
import { packageMasterService } from "./services/packageMasterService";
import { organizationMasterService } from "./services/organizationMasterService";
// import cityReducer from "./slices/citySlice";
// import { cityService } from "./services/cityService";
import organizationMasterReducer from "./slices/organizationMasterSlice";
import { projectUserMasterService } from "./services/projectUserMasterService";
import projectUserMasterReducer from "./slices/projectUserMasterSlice";
import { projectPhaseActivityService } from "./services/projectPhaseActivityService";
import projectPhaseActivityReducer from "./slices/projectPhaseActivitySlice";
import { kRAMasterService } from "./services/kRAMasterService";
import kRAMasterReducer from "./slices/kRAMasterSlice";
import { timeSheetService } from "./services/timeSheetService";
import timeSheetReducer from "./slices/timeSheetSlice";

export const store = configureStore({
  reducer: {
    // Slices
    auth: authReducer,
    allUser: allUserReducer,
    states: statesReducer,
    country: countryReducer,
    // city: cityReducer,
    departmentMaster: departmentMasterReducer,
    projectMaster: projectMasterReducer,
    projectTypeMaster: projectTypeMasterReducer,
    phaseMaster: phaseMasterReducer,
    projectUserMaster: projectUserMasterReducer,
    projectPhaseActivity: projectPhaseActivityReducer,
    kRAMaster: kRAMasterReducer,
    timeSheet: timeSheetReducer,
    audit: auditReducer,
    auditFramework: auditFrameworkReducer,
    company: companyReducer,
    groupMaster: groupMasterRreducer,
    generatePdf: generatePdfRreducer, 
    allUserRole: allUserRoleReducer,
    allUserGroup: allUserGroupReducer,
    packageMaster: packageMasterReducer,
    organizationMaster: organizationMasterReducer,
  
    // Services
    [authService.reducerPath]: authService.reducer,
    [allUserService.reducerPath]: allUserService.reducer,
    [departmentMasterService.reducerPath]: departmentMasterService.reducer,
    [projectMasterService.reducerPath]: projectMasterService.reducer,
    [projectTypeMasterService.reducerPath]: projectTypeMasterService.reducer,
    [phaseMasterService.reducerPath]: phaseMasterService.reducer,
    [projectUserMasterService.reducerPath]: projectUserMasterService.reducer,
    [projectPhaseActivityService.reducerPath]: projectPhaseActivityService.reducer,
    [kRAMasterService.reducerPath]: kRAMasterService.reducer,
    [timeSheetService.reducerPath]: timeSheetService.reducer,
    [auditService.reducerPath]: auditService.reducer,
    [auditFrameworkService.reducerPath]: auditFrameworkService.reducer,
    [companyService.reducerPath]: companyService.reducer,
    [groupMasterService.reducerPath]: groupMasterService.reducer,
    [pdfService.reducerPath]: pdfService.reducer,
    [allUserRoleService.reducerPath]: allUserRoleService.reducer,
    [allUserGroupService.reducerPath]: allUserGroupService.reducer,
    [stateService.reducerPath]: stateService.reducer,
    [countryService.reducerPath]: countryService.reducer,
    // [cityService.reducerPath]: cityService.reducer,
    [packageMasterService.reducerPath]: packageMasterService.reducer,
    [organizationMasterService.reducerPath]: organizationMasterService.reducer,

  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    })
      .concat(authService.middleware)
      .concat(allUserService.middleware)  
      .concat(departmentMasterService.middleware)
      .concat(projectMasterService.middleware)
      .concat(projectTypeMasterService.middleware)
      .concat(phaseMasterService.middleware)
      .concat(projectUserMasterService.middleware)
      .concat(projectPhaseActivityService.middleware)
      .concat(kRAMasterService.middleware)
      .concat(timeSheetService.middleware)
      .concat(auditService.middleware)
      .concat(auditFrameworkService.middleware)
      .concat(companyService.middleware)
      .concat(groupMasterService.middleware)
      .concat(pdfService.middleware)
      .concat(allUserRoleService.middleware)
      .concat(allUserGroupService.middleware)
      .concat(stateService.middleware)
      .concat(countryService.middleware)
      // .concat(cityService.middleware)
      .concat(packageMasterService.middleware)
      .concat(organizationMasterService.middleware)
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
